import authRoute from './auth/routes';
import dashboardRoute from './dashboard/routes';
import customerRoutes from './customers/routes';
import userRoutes from './users/routes';
import tenantRoutes from './tenants/routes';
import revenueRoutes from './revenue/routes/revenue.route';
import payoutHistoryRoutes from './payout-history/routes/payoutHistory.route';
import settingsRoutes from './settings/routes/settings.route';
import notificationRoutes from './notifications/routes/notification.route';
import { appLayoutRoute, authLayoutRoute } from './layout';

// App routes with layout
const appRoutes = appLayoutRoute.addChildren([
  ...dashboardRoute,
  ...customerRoutes,
  ...userRoutes,
  ...tenantRoutes,
  ...revenueRoutes,
  ...payoutHistoryRoutes,
  ...settingsRoutes,
  ...notificationRoutes
]);

// Auth routes without app layout
const authRoutes = authLayoutRoute.addChildren(authRoute);

export default [appRoutes, authRoutes];
